'use client';
import Typography from '@/components/shared/typography/typography.component';
import { useSellCarNew, useTranslation } from '@/hook';
import {
    Path1ThankYou,
    Path1ThankYouVisitWarehouse,
    Path2ThankYou,
    Path2ThankYouVisitWarehouse,
    ShowroomImageSell,
} from '../../../../public/Images';
import { IReceiptForSellForm } from '@/types';
import styles from './styles.module.scss';
// import Disclaimer from '../disclaimer/disclaimer.component';
import ThankYouInspectionDetails from './thank-you-inspection-details.component';
import Image from 'next/image';
import SylndrWorkingHoursLocation from '../sylndr-hub-location/sylndr-hub-workings-hours-location-container/sylndr-hub-workings-hours-location-container.component';

const SellCarThankYou = ({
    path,
    inspectionCase,
}: {
    path: 'path1' | 'path2';
    formData: IReceiptForSellForm[];
    inspectionCase:
        | 'case1'
        | 'case2'
        | 'case3'
        | 'caseNone'
        | 'caseWarehouseInspection';
}) => {
    const { t } = useTranslation();
    const {
        getMake,
        getModel,
        getKilometers,
        getYear,
        getFormRecieptForThankYouPage,
    } = useSellCarNew();
    const make = getMake();
    const model = getModel();
    const kilometers = getKilometers();
    const year = getYear();
    const receipt = getFormRecieptForThankYouPage();

    const determineImage = () => {
        if (path === 'path1') {
            if (inspectionCase === 'caseWarehouseInspection')
                return ShowroomImageSell;
            else if (inspectionCase === 'case1') return Path1ThankYou;
            else return Path1ThankYouVisitWarehouse;
        }
        if (inspectionCase === 'caseNone') return Path2ThankYou;
        else return Path2ThankYouVisitWarehouse;
    };
    const determineText = (): { headerText: string; subHeaderText: string } => {
        if (path === 'path1') {
            if (inspectionCase === 'caseWarehouseInspection')
                return {
                    headerText: t('dataCollectionCompleteHeaderWarehousePath1'),
                    subHeaderText: t(
                        'dataCollectionCompleteSubHeaderWarehousePath1'
                    ),
                };
            else if (inspectionCase === 'case1') {
                return {
                    headerText: t('dataCollectionCompleteHeaderPath1'),
                    subHeaderText: t('dataCollectionCompleteSubHeaderPath1'),
                };
            } else {
                return {
                    headerText: t('dataCollectionCompleteHeaderCase2'),
                    subHeaderText: t('dataCollectionCompleteSubHeaderCase2'),
                };
            }
        }
        if (inspectionCase === 'caseNone') {
            return {
                headerText: t('dataCollectionCompleteHeaderPath2'),
                subHeaderText: !year?.inShoppingList
                    ? t('dataCollectionCompleteSubHeaderPath2', {
                          make: make?.nameEn,
                          model: model?.nameEn,
                          year: year.year,
                      })
                    : t('dataCollectionCompleteSubHeaderKmPath2', {
                          make: make?.nameEn,
                          model: model?.nameEn,
                          km: `${kilometers.displayed.split('-')[0]} ${t(
                              'km'
                          )}`,
                      }),
            };
        } else {
            return {
                headerText: t('dataCollectionCompleteHeaderCase3'),
                subHeaderText: t('dataCollectionCompleteSubHeaderCase3'),
            };
        }
    };

    const img = determineImage();
    const { headerText, subHeaderText } = determineText();

    const formatSubHeaderText = (text: string) => {
        if (inspectionCase === 'case2' || inspectionCase === 'case3')
            return text;
        const formatedString = text.split('.');

        const textNodes = formatedString.map(text => (
            <Typography
                key={text}
                color={'#667085'}
                variant="body2"
                component={'span'}
            >
                {text}. <br></br>{' '}
            </Typography>
        ));
        return textNodes;
    };

    const determineImgElem = (): JSX.Element => {
        if (inspectionCase === 'caseWarehouseInspection') {
            return (
                <div className={styles.main_picture_container}>
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img
                        className={styles.main_picture}
                        src={img.src}
                        alt="thank you"
                    />
                </div>
            );
        }
        if (inspectionCase !== 'case3') {
            return (
                <div className={styles.main_img_container}>
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img
                        className={styles.main_img}
                        src={img.src}
                        alt="thank you"
                    />
                </div>
            );
        }
        return (
            <div className={styles.main_img_container}>
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                    className={styles.main_img}
                    src={img.src}
                    alt="thank you"
                />
            </div>
        );
    };
    const imgElement = determineImgElem();
    const bgColor =
        path === 'path1' || inspectionCase === 'case3' ? '#F3FFFA' : '#FFFCF5';
    const borderColor =
        path === 'path1' || inspectionCase === 'case3' ? '#CCF5E5' : '#FEF0C7';
    const headerColor =
        path === 'path1' || inspectionCase === 'case3' ? '#009B5D' : '#93370D';
    const itemTextColor =
        path === 'path1' || inspectionCase === 'case3' ? '#00673E' : '#B54708';
    return (
        <div className={styles.main_layout_container}>
            {imgElement}
            <div>
                <Typography
                    style={{ maxWidth: '420px' }}
                    color={'#101828'}
                    variant="subtitle2Medium"
                >
                    {headerText}
                </Typography>
                <Typography
                    style={{
                        maxWidth: '420px',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                    color={'#667085'}
                    variant="body2"
                    component={'div'}
                >
                    {formatSubHeaderText(subHeaderText)}
                </Typography>
            </div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                }}
            >
                {(inspectionCase === 'case2' || inspectionCase === 'case3') && (
                    <div>
                        <ThankYouInspectionDetails />
                    </div>
                )}
                {inspectionCase === 'caseWarehouseInspection' && (
                    <div>
                        <SylndrWorkingHoursLocation />
                    </div>
                )}
                <section
                    className={styles.car_details_section}
                    style={{
                        backgroundColor: bgColor,
                        borderColor: borderColor,
                    }}
                >
                    <Typography color={headerColor} variant="body2SemiBold">
                        {t('car Details')}
                    </Typography>
                    {receipt.map(
                        item =>
                            item.value !== '' && (
                                <div
                                    className={styles.car_details_item}
                                    key={item.value}
                                >
                                    <div
                                        className={
                                            styles.car_details_item_section
                                        }
                                    >
                                        <Image
                                            width={20}
                                            height={20}
                                            src={item.icon}
                                            alt={item.value}
                                        />
                                        <Typography
                                            color={itemTextColor}
                                            variant="body2"
                                            component={'span'}
                                        >
                                            {t(item.label)}
                                        </Typography>
                                    </div>

                                    <div
                                        className={
                                            styles.car_details_item_section
                                        }
                                    >
                                        {item.iconValue !== '' && (
                                            <Image
                                                width={20}
                                                height={20}
                                                src={item.iconValue as string}
                                                alt={item?.label}
                                            />
                                        )}
                                        <Typography
                                            color={'#101828'}
                                            variant="body2"
                                        >
                                            {item.value}
                                        </Typography>
                                    </div>
                                </div>
                            )
                    )}
                </section>
            </div>
        </div>
    );
};
export default SellCarThankYou;
